<script>
  import Send from '~icons/mdi/send';
  import { verifyEmailModal } from '~/auth/Verification.svelte';
  import ActionButton from '~/components/ActionButton.svelte';
  import { pendingVerification } from '~/auth/utils.svelte';

  const handleOpenVerification = () => {
    verifyEmailModal.push(pendingVerification.current);
  };
</script>

<ActionButton onClick={handleOpenVerification}>
  <Send />
  Resend Email
</ActionButton>
